import PrimaryCell from "../../../../../../../../../ui/Table/Cells/PrimaryCell";
import DateCell from "../../../../../../../../../ui/Table/Cells/DateCell";
//import EducationInfoCell from "../../../RequestRelations/RelationStudentsTable/EducationInfoCell";

export const columns = [{
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 32
  },
  {
    dataField: "name",
    caption: "ФИО обучающегося",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 100
  },
  {
    dataField: "email",
    caption: "Email",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 100
  },
  {
    dataField: "birthday",
    caption: "Дата рождения",
    dataType: "date",
    cellRender: DateCell,
    width: 100
  },
  {
    dataField: "snils",
    caption: "СНИЛС",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 100
  },
  /*{
    dataField: "programId",
    caption: "Информация об обучении",
    dataType: "string",
    cellRender: EducationInfoCell
  }*/
  ];
